//import '../src/App.css';

function Navigation() {
    return (

<nav>
        <div id="menu-bar">
          <span id="menu-one">Movie Book</span>
          <span>Home</span>
          <span>About Us</span>
          <span>Know More</span>
        </div>
      </nav>

);
}

export default Navigation;
